export enum PermissionScope {
    View = 1,
    Edit = 2,
}
